import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from './App';
import { isClerkEnabled, initClerkSso } from './lib/clerkSso';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
    },
  },
});

// CLERK_BOOT — Clerk doit être prêt AVANT React : `useCurrentUser()` n'appelle
// /api/auth/me que si un jeton existe déjà en localStorage. Vaut pour le hub
// comme pour le mode natif — dans les deux cas, une session Clerk déjà ouverte
// doit être reconnue au premier rendu, sans passer par l'écran de connexion.
async function bootstrap() {
  if (isClerkEnabled()) {
    await initClerkSso();
  }
  ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  </React.StrictMode>
  );
}

void bootstrap();
